import { getArchive } from "apis/archive/archive";
import { useEffect, useState } from "react";
import { LinkCardContainer } from "./LinkCard.style";

interface LinkCardProps {
  url: string;
  year: number;
}

const LinkCard = ({ url, year }: LinkCardProps) => {
  const [archiveUrl, setArchiveUrl] = useState<string>("");
  useEffect(() => {
    getArchive(url, year).then((res) => {
      if (res.archived_snapshots.hasOwnProperty("closest")) {
        setArchiveUrl(res.archived_snapshots.closest.url);
      }
    });
  }, []);
  return (
    <>
      {archiveUrl ? (
        <LinkCardContainer>
          <h2>🕜{year}년</h2>
          <div>
            <p>URL정보: </p>
            <a href={archiveUrl} target="_blank" rel="noreferrer">
              {archiveUrl}
            </a>
          </div>
        </LinkCardContainer>
      ) : undefined}
    </>
  );
};

export default LinkCard;
